import { io } from "socket.io-client";
// "undefined" means the URL will be computed from the `window.location` object

const URL = process.env.NODE_ENV === 'production' ? "https://onemauve.com" :"https://onemauve.com";

// const URL="http://dev.onemauve.com"

export const socket = io(URL);
